import React, { useEffect, useState } from "react"
import { withRouter, Link } from "react-router-dom"
import MetaTags from "react-meta-tags"
import { Container } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import { Filters } from "./Filters"
import Table from "./Table"
import axios from "axios"
import {API_URL, sitename} from "constants/constants"
import moment from "moment";

const RafReport = props => {
  const [RAFReport, setRAFReport] = useState([])
  const [toDate, setToDate] =useState(moment().format("YYYY-MM-DD"))
  const [fromDate, setFromDate] =useState(moment().format("YYYY-MM-DD"))
  const [item, setItem] = useState('All')
  const [loadingMessage, setLoadingMessage] = useState("1");
  useEffect(() => {
    call()
  }, [])

  const call = () => {
    setLoadingMessage("1");
    axios({
      method: "get",
      url: `${API_URL}/admin/reports/raf-report?to=${toDate}&from=${fromDate}&type=${item}`,
    })
        .then(function (response) {
          setRAFReport(response?.data?.data)
          setLoadingMessage("0");
        })
        .catch(function (response) {
        })
  }


  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Admin" breadcrumbItem="Raf Report" />
        </Container>
        <Filters
            fromDate={fromDate}
            toDate={toDate}
            setToDate={setToDate}
            setFromDate={setFromDate}
            item={item}
            setItem={setItem}
            call={e => {
              call()
            }}
        />
        <Table
            data={RAFReport}
            setLoadingMessage={setLoadingMessage}
            loadingMessage={loadingMessage}
        />
      </div>
    </React.Fragment>
  )
}

export default withRouter(RafReport)
